import React, { useState } from "react";
import {
    CogIcon,
    UserIcon,
    BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateDeclaration } from "../../services/redux/ApiActions";
import showNotification from "../../services/redux/NotifcationService";
import Stepper from "../Common/Stepper";
import LogoDiv from "../Common/LogoDiv";
import logo from '../../img/BBPS_Horizontal.png'


export default function StepFourDeclarationProperitor() {
    const details = useSelector((state) => state.details.details);
    const customerData = useSelector((state) => state.customerData.customerData);

    const gstinResponse = JSON.parse(details?.result.gstinResponse);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    function formatDate(dateString) {
        const date = new Date(dateString);

        // Array of month names
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        // Get the month, day, year, hours, and minutes
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes();
        const period = date.getHours() < 12 ? "AM" : "PM";

        // Construct the formatted date string
        const formattedDate = `${month} ${day}, ${year} ${hours}:${minutes.toString().padStart(2, '0')} ${period}`;

        return formattedDate;
    }
    const handleSubmit = async () => {
        const payload = {
            "customerId": customerData?.custId,
            "declarationSignedIp": "",
            "declarationSignedUserAgent": ""
        }
        try {
            const data = await dispatch(updateDeclaration(payload, customerData?.token_chr));
            if (data.statusCode === 200) {
                navigate('/Customer/Step5');
                showNotification('Declaration Updated Successfully', 'success');
            }
        } catch (error) {
            showNotification(error, 'error');
        }
    }

    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <CustomerHeader />

                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <Stepper />
                                <div className='bg-white mx-2 shadow-xl p-3 mt-4 rounded-lg'>
                                <div className="grid grid-cols-12 gap-4">
 <div className="col-span-12 md:col-span-2 lg:col-span-2">
</div>
 <div className="col-span-12 md:col-span-8 lg:col-span-8">
 <div className="py-2 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">DECLARATION
                                        </h1>
                                    </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                                    <div style={{display:'flex',justifyContent:'right',marginTop:'-5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
                                    </div>
 </div>     
                                    <div className="pt-5 pb-1 px-4">
                                        <h1 className="text-md text-gray-600 declaration-css">I certify that M/s.<label className="font-bold underline">{"    " + details?.result.customerName + "    "}</label>({gstinResponse?.FullAddress}) is a {details?.result.businessType} firm</h1>
                                    </div>
                                    <div className="py-2 px-4">
                                        <h1 className="text-md text-gray-600 declaration-css mt-4">Please find list of partners of the said Firm and their PAN details below:
                                        </h1>
                                    </div>
                                    <div className="overflow-x-auto border rounded-md shadow-sm mt-3">
                                        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase w-10 border-r-2">
                                                        Sr.No
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase w-40 border-r-2">
                                                        Name
                                                    </th>

                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase w-40 border-r-2">
                                                        PAN
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {details?.result.partners.map((partner, index) => (
                                                    <tr key={index} className="border-t">
                                                        <td className="px-3 text-sm py-4 border-r">
                                                            {index + 1}
                                                        </td>
                                                        <td className="px-3 text-sm py-4 border-r">
                                                            {partner.partnerName}
                                                        </td>
                                                        <td className="px-3 text-sm py-4 border-r">
                                                            {partner.partnerPAN}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="mt-4 col-span-12 md:col-span-7 lg:col-span-7">
                                        <div className="relative text-center">
                                            <button onClick={handleSubmit} disabled={(details?.result.declarationSigned !== null && details?.result.declarationSigned !== 1) ? true : false} className="vtpRm-action-button">
                                                {(details?.result.declarationSigned !== null && details?.result.declarationSigned !== 1) ? `Declaration Signed at ${formatDate(details?.result.declarationSignedAt)}` : 'Confirm and Proceed'}
                                            </button>
                                            {details?.result.declarationSigned !== null && details?.result.declarationSigned !== 1 ? <>
                                                <span className="skip-btn hover:cursor-pointer py-4 px-4" onClick={() => navigate('/Customer/Step5')} >
                                                    Skip this step
                                                </span>
                                            </> : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body >
        </>
    );
}